exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NoLimitsAvailable_block__description_3leY {\n    margin-bottom: 24px;\n  }\n  .NoLimitsAvailable_block__button_1Ctw {\n    margin-bottom: 24px;\n  }\n  .NoLimitsAvailable_block__icon_1kQw {\n    margin-left: 4px;\n\n    -webkit-transform: rotate(180deg);\n\n            transform: rotate(180deg);\n  }\n", ""]);

// exports
exports.locals = {
	"block__description": "NoLimitsAvailable_block__description_3leY",
	"block__button": "NoLimitsAvailable_block__button_1Ctw",
	"block__icon": "NoLimitsAvailable_block__icon_1kQw"
};